// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import vSelect from 'vue-select'

import App from './components/app-component/app-component'
import router from './router'
import store from './store'

import StringFile from './assets/localization/string'

import BootstrapVue from 'bootstrap-vue'

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.component('v-select', vSelect)

// console tips
Vue.config.productionTip = false

// vue resource config
Vue.http.options.root = process.env.HOST_IDP2

// global variables
Vue.prototype.$hostIdp2 = process.env.HOST_IDP2
Vue.prototype.$hostEps = process.env.HOST_EPS
Vue.prototype.$environment = process.env.NODE_ENV
Vue.prototype.$stringFile = StringFile

// global functions
/**
 * Interceptor used for postprocessing of a request.
 */
Vue.http.interceptors.push((request, next) => {
  // console.log('request', request)
 
  next((response) => {
    if (response.status === 401) {
      if (store.getters.getRefreshToken && store.getters.getStateToken) {
        // Clear IDP session on backend side
        Vue.http.post('v1/ondusapi/oidc/webauth/logout',
          {
            'refresh_token': this.$store.getters.getRefreshToken,
            'state_token': this.$store.getters.getStateToken
          })
          .then(response => {
            console.log('POST v1/ondusapi/oidc/webauth/logout', response) // 204 with empty response.body
            // Clear user session on backend side on 401
            Vue.prototype.$clearSession()
          })
          .catch(err => {
            console.error('Error:', err)
            // Clear Vuex store state on error
            Vue.prototype.$removeStoredData(false)
          })
      } else {
        // Clear Vuex store state on error during authentication process
        console.log('Refresh token - State token not found.')
        Vue.prototype.$removeStoredData(false)
      }
    }
  })
})

Vue.prototype.$manageError = (error) => {
  // error.status = 401 is handled in Vue.http.interceptors.
  console.error('Si è verificato un errore.')
  console.error('$manageError:', error)
  router.push({ name: 'error', params: { errorCode: error.status } })
}

/**
 * Clear user session.
 * @param error
 */
Vue.prototype.$clearSession = () => {
  // Clear Vuex store state and push to login
  Vue.prototype.$removeStoredData(true)
}

/**
 * Clear Vuex store state.
 * @param checkRedirect, push to login if it is true.
 */
Vue.prototype.$removeStoredData = (checkRedirect) => {
  console.log('$removeStoredData')
  store.commit('setNotificationBar', null)
  store.commit('setStateToken', null)
  store.commit('setAccessToken', null)
  store.commit('setRefreshToken', null)
  store.commit('setExpiresIn', null)
  store.commit('setUser', null)
  if (checkRedirect) {
    // Push to login
    router.push('/')
  }
}

/**
 * Commit mutations.
 * @param res, refresh token response.
 */
Vue.prototype.$storeOAuth = (res) => {
  store.commit('setAccessToken', res.access_token)
  store.commit('setRefreshToken', res.refresh_token)
  store.commit('setStateToken', res.state_token)
  store.commit('setExpiresIn', res.expires_in)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js